import { RootState } from 'editor/src/store/index';

const isShopifyOptionsInfoBannerDismissed = (state: RootState) =>
  state.editorModules.sidebar.isShopifyOptionsInfoBannerDismissed;

export default isShopifyOptionsInfoBannerDismissed;
